import { getFromLocalStorage, setToLocalStorage } from '@shared/lib/storage'
import {
	DEFAULT_LOCALE,
	localeMeta,
	SUPPORTED_LOCALES,
	type BackendLocale,
	type SupportedLocale,
} from './types'

const supportedLocaleSet = new Set<string>(SUPPORTED_LOCALES)

export const isSupportedLocale = (locale: string): locale is SupportedLocale =>
	supportedLocaleSet.has(locale)

export const normalizeLocale = (locale?: string | null): SupportedLocale => {
	const normalized = locale?.trim().toLowerCase()

	if (!normalized) {
		return DEFAULT_LOCALE
	}

	const baseLocale = normalized.split(/[-_]/)[0]

	if (isSupportedLocale(baseLocale)) {
		return baseLocale
	}

	return DEFAULT_LOCALE
}

export const toBackendLocale = (locale: SupportedLocale): BackendLocale => locale

export const resolveInitialLocale = async (
	profileLocale?: BackendLocale | null
): Promise<SupportedLocale> => {
	const storedLocale = await getFromLocalStorage('preferredLocale')

	if (typeof storedLocale === 'string') {
		return normalizeLocale(storedLocale)
	}

	if (profileLocale) {
		return normalizeLocale(profileLocale)
	}

	return normalizeLocale(window.navigator.language)
}

export const persistLocale = async (locale: SupportedLocale): Promise<void> => {
	await setToLocalStorage('preferredLocale', locale)
}

export const applyLocaleToDocument = (locale: SupportedLocale): void => {
	document.documentElement.lang = locale
	document.documentElement.dir = localeMeta[locale].dir
}
